import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_mt-a" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { "data-qa": "project-card:PreviewDetailsFollowText" }
const _hoisted_4 = { "format-key": "1" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  class: "gfu-bt gfu-bt--caption _tc--lighter",
  "data-qa": "project-card:PreviewDetailsFollowCaption"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_timer_component = _resolveComponent("timer-component")
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.campaignStart)
      ? (_openBlock(), _createBlock(_component_timer_component, {
          key: 0,
          timestamp: $props.campaignStart
        }, null, 8 /* PROPS */, ["timestamp"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!$options.isFollowing)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  ($props.hasPromoItem)
                    ? (_openBlock(), _createBlock(_component_localize, {
                        key: 0,
                        resource: _ctx.Resources.Homepage.ProjectCardFollowWithGiftTextPart1
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            "format-key": "0",
                            class: "gfu-link _tc--accent",
                            onClick: _cache[0] || (_cache[0] = (...args) => ($options.onClick && $options.onClick(...args))),
                            "data-qa": "project-card:PreviewDetailsFollowLink"
                          }, _toDisplayString(_ctx.Resources.Homepage.ProjectCardFollowWithGiftTextPart2), 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_4, _toDisplayString($options.promoTypeLabel), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["resource"]))
                    : (_openBlock(), _createBlock(_component_localize, {
                        key: 1,
                        resource: _ctx.Resources.Homepage.ProjectCardFollowWithNoGiftTextPart1
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            "format-key": "0",
                            class: "gfu-link _tc--accent",
                            onClick: _cache[1] || (_cache[1] = (...args) => ($options.onClick && $options.onClick(...args))),
                            "data-qa": "project-card:PreviewDetailsFollowLink"
                          }, _toDisplayString(_ctx.Resources.Homepage.ProjectCardFollowWithNoGiftTextPart2), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["resource"]))
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.Resources.Homepage.ProjectCardIsFollowingText), 1 /* TEXT */))
          ]),
          _createElementVNode("span", _hoisted_6, _toDisplayString($options.caption), 1 /* TEXT */)
        ]))
  ]))
}